const DEFAULT_TITLE = "IceFleet — Iceland Private Transport";
const DEFAULT_DESCRIPTION = "IceFleet — Van rental, private airport transfers and tours across Iceland.";

function upsertTag(selector, create) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = create();
    document.head.appendChild(node);
  }
  return node;
}

export function applySeo({ title, description, canonicalPath }) {
  document.title = title || DEFAULT_TITLE;

  const descriptionTag = upsertTag('meta[name="description"]', () => {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    return meta;
  });
  descriptionTag.setAttribute("content", description || DEFAULT_DESCRIPTION);

  if (canonicalPath) {
    const canonicalTag = upsertTag('link[rel="canonical"]', () => {
      const link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      return link;
    });
    canonicalTag.setAttribute("href", `${window.location.origin}${canonicalPath}`);
  }
}